import { filterColumns } from './Columns/helpers';
import {
  ModernPaginationProps,
  Table,
  TableProps,
} from '@moneyforward/ap-frontend-components';
import type { InvoiceReportDetailJournalEntriesResponseItem } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import { useColumns } from './Columns';
import styles from './Table.module.scss';

const cx = classnames.bind(styles);

export type InternalTableProps = Omit<
  TableProps<InvoiceReportDetailJournalEntriesResponseItem & { id: string }>,
  'columns' | 'pagination' | 'emptyType'
>;

type Props = {
  table: InternalTableProps;
  pagination: ModernPaginationProps;
  listColumns?: string[];
};

export const JournalInfoTable: FC<Props> = memo(
  ({ table, pagination, listColumns }) => {
    const columns = useColumns();
    const scroll = useMemo(() => ({ x: 'max-content' as const }), []);

    /** Filter columns show base on the listEntries return from api */
    const filteredColumns = useMemo(() => {
      if (!listColumns) return columns;
      return filterColumns(columns, listColumns);
    }, [columns, listColumns]);

    return (
      <div className={cx(styles['container'])} data-testid='journal-info-table'>
        <Table
          {...table}
          legacy={false}
          testId='journal-info-table'
          columns={filteredColumns}
          scroll={scroll}
          pagination={pagination}
          rowKey='id'
          hideFooterPagination
        />
      </div>
    );
  }
);
JournalInfoTable.displayName = 'JournalInfoTable';
